export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.b1cc1343.worker.js");
}
